module.exports = __webpack_public_path__ + "img/Adora-Nzewi.097baf48.jpg";